import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';
import { AgGrid, gridConstants as gc, filters, filterParams } from '../AgGrid';
// import { getOrdersColumnDefinitions } from '../../../helpers/columnDefinitions';
// import PropTypes from "prop-types";

// SERVICES
import { getClientList } from '../../services';

const styles = theme => ({
  gridContainer: {
    flex: 1,
    alignSelf: 'stretch',
  },
});

export const ClientGrid = withStyles(styles)(props => {
  const { classes } = props;

  const [clientRowData, setClientRowData] = useState(null);

  const columnDefinitions = [
    // { headerName: '', cellRenderer: () => 'EDIT', width: 100, filter: false, sortable: false, },
    { headerName: 'Name', field: 'name', width: 250, editable: false },
    {
      headerName: 'Record Type',
      field: 'recordType',
      width: 100,
      editable: false,
      filter: filters.set,
      filterParams: {
        values: ['Active', 'Inactive'],
      },
      boolean: true,
    },
    { headerName: 'Code', field: 'code', width: 100 },
    {
      headerName: 'Primary Address',
      field: 'clientAddress',
      cellRenderer: params => {
        const pAddr = params.value.filter(ad => ad.AddressType === 'Primary');
        return pAddr.length ? `${pAddr[0].ad1} ${pAddr[0].city}, ${pAddr[0].st} ${pAddr[0].zip}` : '';
      },
    },
    {
      headerName: 'Billing Address',
      field: 'clientAddress',
      cellRenderer: params => {
        const pAddr = params.value.filter(ad => ad.AddressType === 'Billing');
        return pAddr.length ? `${pAddr[0].ad1} ${pAddr[0].city}, ${pAddr[0].st} ${pAddr[0].zip}` : '';
      },
    },
    {
      headerName: 'Mailing Address',
      field: 'clientAddress',
      cellRenderer: params => {
        const pAddr = params.value.filter(ad => ad.AddressType === 'Mailing');
        return pAddr.length ? `${pAddr[0].ad1} ${pAddr[0].city}, ${pAddr[0].st} ${pAddr[0].zip}` : '';
      },
    },
    {
      headerName: 'Delivery Method',
      filter: filters.set,
      valueGetter: ({ data }) => {
        const text = data.clientSettings?.[0]?.reportPreference ?? '';
        return text.toUpperCase();
      },
    },
    { headerName: 'Alias', field: 'alias', width: 150 },
    {
      headerName: 'Active Date',
      field: 'activeDate',
      width: gc.DATE_FIELD_WIDTH,
      cellRenderer: 'dateUTC',
      filter: filters.date,
      filterParams: filterParams.date,
    },
    { headerName: 'Corporate Customer', field: 'corporateCustomer', width: 100 },
    { headerName: 'New Client', field: 'new', width: 100 },
    { headerName: 'VIP Client', field: 'vip', width: 100 },
    { headerName: 'Introduced to CE', field: 'csintro ', width: 100 },
    { headerName: 'Created On', field: 'createdOn', width: gc.DATE_FIELD_WIDTH },
    { headerName: 'Created By', field: 'createdBy' },
    { headerName: 'Modified On', field: 'modifiedOn', width: gc.DATE_FIELD_WIDTH },
    { headerName: 'Modified By', field: 'modifiedBy' },
  ];

  const getClients = async () => {
    try {
      const rowData = await getClientList();
      setClientRowData(rowData);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getClients();
  }, []);

  return (
    <div className={classnames('grid-container', classes.gridContainer)}>
      <AgGrid
        gridData={clientRowData}
        columnDefs={columnDefinitions}
        redirectOnClick={true}
        editOnClick={false}
        showCreateButton={true}

        // gridData={[]}
        // columnDefs={columnDefinitions}
        // handleCreateClick={evt =>
        //   (window.location = `${window.location.href}/create`)
        // }
        // showCreateButton={true}
        // // handleCellClick={evt =>
        // //   (window.location = `${window.location.href}/${evt.data.orderTicket}`)
        // // }
        // redirectOnClick={true}
        // editOnClick={false}
        // // gridOptions={gridOptions}
        // // tableHeader={"Orders"}
        // // openBulkEditDialog={openBulkEditDialog}
        // datasourceUrl={'/orders'}
        // useDatasource={true}
        // gridName={'MAIN_GRID'}
      />
    </div>
  );
});

ClientGrid.propTypes = {};

ClientGrid.defaultProps = {};
